/* lv-galeria-karty (26.09.2026): na kartach produktow (kolekcje, polecane) po najechaniu kursorem zdjecia zmieniaja sie
   po kolei co 1,5 s, a paski na gorze pokazuja liczbe zdjec i postep (wzor: topestetic.pl). Tylko urzadzenia z kursorem.
   Dane: snippet card-product, div.lv-galeria[data-lv-galeria="url|url|..."]. */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  var CZAS = 1500;
  function stop(g) {
    clearTimeout(g._lvT);
    g.classList.remove('is-aktywna');
    g.querySelectorAll('.lv-galeria__pasek').forEach(function (p) { p.className = 'lv-galeria__pasek'; });
  }
  function pokaz(g, i) {
    var urls = g._lvUrls, img = g._lvImg;
    img.src = urls[i];
    var nast = new Image(); nast.src = urls[(i + 1) % urls.length];
    g.querySelectorAll('.lv-galeria__pasek').forEach(function (p, k) {
      p.className = 'lv-galeria__pasek' + (k < i ? ' is-pelny' : k === i ? ' is-biezacy' : '');
    });
    g._lvT = setTimeout(function () { pokaz(g, (i + 1) % urls.length); }, CZAS);
  }
  function start(g) {
    if (!g._lvUrls) {
      g._lvUrls = (g.dataset.lvGaleria || '').split('|').filter(Boolean);
      g._lvImg = document.createElement('img');
      g._lvImg.className = 'lv-galeria__img'; g._lvImg.alt = ''; g._lvImg.decoding = 'async';
      g.insertBefore(g._lvImg, g.firstChild);
    }
    if (g._lvUrls.length < 2) return;
    clearTimeout(g._lvT);
    g.classList.add('is-aktywna');
    pokaz(g, 0);
  }
  document.addEventListener('mouseover', function (e) {
    var m = e.target.closest && e.target.closest('.card__media');
    if (!m) return;
    var g = m.querySelector('.lv-galeria');
    if (!g || g.classList.contains('is-aktywna')) return;
    start(g);
    m.addEventListener('mouseleave', function h() { m.removeEventListener('mouseleave', h); stop(g); });
  });
})();
